<template>
  <div class="captcha">
    <slot name="txtBefore"></slot>
    <img :src="'data:image/jpeg;base64,' + captcha.image" alt="" />
    <b-input v-model="captchaCode" @input='updateInput()' placeholder="Captcha-Code"></b-input>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { mapGetters } from 'vuex'
export default {
  name: 'Captcha',
  data () {
    return {
      captcha: {
        image: '',
        token: ''
      },
      captchaCode: ''
    }
  },
  methods: {
    updateInput () {
      this.$emit('captchaCode', { captchaCode: this.captchaCode, captchaToken: this.captcha.token })
    }
  },
  computed: {
    ...mapGetters(['brand'])
  },
  apollo: {
    captcha: function () {
      return wrapQuery(gql`query captcha ($brand: String!) {
        captcha (brand: $brand) {
          image,
          token
        }
      }`, this, 'captcha', { brand: this.brand })
    }
  }
}
</script>
